﻿import {isNullOrEmpty} from "@2d-front-monorepo/core";
import {DriverId, Drivers, PermitId, Permits} from "@2d-front-monorepo/permits-business";

import {JSX} from "react";
import {useSearchParams} from "react-router";
import {usePermits} from "../../hooks/usePermits";

export default function CreateDriver(): JSX.Element {
	const [searchParams] = useSearchParams();
	const permitsState = usePermits();

	const permitId = searchParams.get("permitId") as PermitId;
	const driverId = searchParams.get("driverId") as DriverId;

	const permit = isNullOrEmpty(permitId) ? undefined : Permits.find(permitsState, permitId);
	const driver = isNullOrEmpty(driverId) ? undefined : Drivers.get(permitsState, driverId);

	// const EditComponent = Registrations.getCreateResidency();
	// return <EditComponent residency={residency} holderData={holderData} permit={permit}/>;

	return <></>;
}
